/**
 * Util functions for single dataset bar charts
 */

// @ts-ignore
import colours from "styles/_colours.scss";

/**
 * Uses the barColours array to set the background colour of each bar.
 * Falls back to yellow if barColours is missing or contains invalid keys.
 */
const barBackgroundColours = (barColours?: string[]): string[] | string => {
  if (!Array.isArray(barColours) || barColours.length === 0) {
    return colours.yellow;
  }

  return barColours.map((colour) => colours[colour] ?? colours.yellow);
};

export const prepareDataForBarChart = (
  chartConfig: BarChartConfig,
): BarChartConfig => {
  const barChartConfigData = {
    labels: chartConfig.labels,
    datasets: chartConfig.datasets.map((dataset) => ({
      label: dataset.label,
      noDataText: dataset.noDataText,
      data: dataset.data,
      backgroundColor: barBackgroundColours(chartConfig.datasets[0].barColours),
      stack: dataset.label,
      status: dataset.status,
      barPercentage: dataset.barPercentage || 0.9,
      categoryPercentage: 0.8,
      datalabels: {
        offset: 1,
        align: "end",
      },
    })),
  };
  return barChartConfigData;
};
